import { INPUT_FIELD_NAMES } from "nlib/common/ContactForm/constants";
import Input from "nlib/ui/Input";
import React from "react";
import useContactFormContext from "nlib/common/ContactForm/useContactFormContext";

const ContactFormPhoneInput = (props) => {
  const { value, disabled, readOnly, onChange } = useContactFormContext(INPUT_FIELD_NAMES.PHONE);

  return (
    <Input
      placeholder="(000) 000-0000"
      {...props}
      disabled={disabled}
      readOnly={readOnly}
      value={value || ""}
      onChange={onChange} />
  );
};

export default React.memo(ContactFormPhoneInput);
